const DEFAULT_EXPORT_OPTIONS = {
    textColor: "#808080",
    chartWidth: 1920,
    chartHeight: 1080,
};
const CSS_VARIABLE_REGEX = /var\(([^)]+)/;
export function exportChartAsCsv(chart, filename) {
    chart.update({ exporting: { filename } });
    chart.downloadCSV();
}
export function exportChartAsImage(chart, filename, title, options = {}) {
    const { textColor, chartWidth, chartHeight } = Object.assign(Object.assign({}, DEFAULT_EXPORT_OPTIONS), options);
    chart.exportChartLocal({ filename }, {
        series: chart.userOptions.series.map((s) => {
            // Detect when CSS variables are used for colours and replace them with the actual colour
            const { color } = s;
            const cssVarMatch = typeof color === "string" && CSS_VARIABLE_REGEX.exec(color);
            if (cssVarMatch && cssVarMatch.length > 1) {
                const color = window.getComputedStyle(document.documentElement).getPropertyValue(cssVarMatch[1]);
                return Object.assign(Object.assign({}, s), { color });
            }
            return s;
        }),
        chart: {
            style: {
                fontSize: "24px",
                fontFamily: "Helvetica, Arial, sans-serif",
                color: textColor,
            },
            height: chartHeight,
            width: chartWidth,
        },
        title: {
            text: title,
            margin: 50,
            style: {
                fontSize: "50px",
                color: textColor,
            },
        },
        legend: {
            enabled: true,
            margin: 50,
            itemStyle: {
                fontSize: "18px",
            },
        },
        yAxis: {
            gridLineWidth: 1,
            gridLineColor: textColor,
            gridLineDashStyle: "Dash",
            tickPixelInterval: 144,
        },
    });
}
